import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PAC_Utils } from "../utils/Utils";

export const ResourceClientManager = (function ( ) {

	const getResourceByIdEvent = LS2PAC_CONSTANTS.Events.onViewResource;

	TLCEventManager.addListener( getResourceByIdEvent, function ( event ) {
		if( event.hostRecordId ) {
			onGetResourceById( LS2PAC_CONSTANTS.restUrls.getResourceByHostRecordId, event.hostRecordId, event.viewName, event.backButtonEvent, event.history );
		} else {
			onGetResourceById( LS2PAC_CONSTANTS.restUrls.getResourceById, event.resourceId, event.viewName, event.backButtonEvent, event.history );
		}
	} );

	var onGetResourceById = function ( url, id, viewName, backButtonEvent, history ) {
		TLCRest.jsonCall( [url, id].join( "/" ), {
			callback: function ( data ) {
				var newData = LS2PAC_Utils.getFakePagingDataToSendToFullDetails( [data] );

				newData.currentResource = newData.resourceData.resources[newData.index];

				if( history !== undefined ) {
					newData.history = history;
				}

				newData.viewName = viewName;

				if( backButtonEvent !== undefined ) {
					ApplicationData.setCurrentBackEvent( backButtonEvent );
					newData.hideBackButton = false;
				} else {
					newData.hideBackButton = true;
				}

				TLCLogger.log( "onGetResourceById", newData );

				if( newData.currentResource && newData.currentResource.id != null ) {
					TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onShowFullDetails, newData );
				} else {
					TLCEventManager.fireEvent( LS2PAC_CONSTANTS.Events.onViewNullResource, newData );
				}
			}
		} );
	};

	return {
		getResourceByIdEvent: getResourceByIdEvent
	};
})();
